import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "addressLookup" };
import { ref, computed, watch, onMounted } from 'vue';
import { useCustomer } from '@/composables/useCustomer';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressLookup',
    props: {
        value: {},
        theme: {},
        showNumber: { type: Boolean }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { lookupAddress: customerLookupAddress } = useCustomer();
        const postCode = ref('');
        const number = ref(null);
        const pageTheme = ref(props.theme || 'dark');
        const results = ref(null);
        const address = ref(null);
        const searching = ref(false);
        const modelValue = computed({
            get() {
                return address.value;
            },
            set(value) {
                address.value = value;
                emit('update:modelValue', address.value);
            }
        });
        function onLoad() {
            if (props.value) {
                postCode.value = props.value.postCode;
                lookupAddress();
                watch(results, (newVal) => {
                    if (newVal) {
                        if (props.value && props.value.line1) {
                            const foundAddress = results.value.find(a => a.line1 === props.value.line1);
                            if (foundAddress) {
                                modelValue.value = foundAddress;
                            }
                            else {
                                modelValue.value = null;
                            }
                        }
                    }
                });
            }
        }
        function lookupAddress() {
            if (!postCode.value || postCode.value.length < 4) {
                return;
            }
            searching.value = true;
            customerLookupAddress(postCode.value, number.value ?? '', (res) => {
                searching.value = false;
                results.value = res.addresses;
            });
        }
        onMounted(() => { onLoad(); });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_select = _resolveComponent("v-select");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!results.value)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: postCode.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((postCode).value = $event)),
                                        type: "text",
                                        label: searching.value ? 'Searching....' : 'Enter postcode',
                                        variant: "solo",
                                        flat: true,
                                        "sin--gle-line": "",
                                        "bg-color": pageTheme.value == 'dark' ? '#ffffffaa' : '#3328470D',
                                        "append-inner-icon": postCode.value && postCode.value.replace(/\s/g, '').length >= 4 ? 'mdi-magnify' : '',
                                        "onClick:appendInner": lookupAddress
                                    }, null, 8, ["modelValue", "label", "bg-color", "append-inner-icon"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (results.value)
                    ? (_openBlock(), _createBlock(_component_v_select, {
                        key: 1,
                        modelValue: modelValue.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((modelValue).value = $event)),
                        "si-ngle-line": "",
                        variant: "solo",
                        flat: true,
                        "append-inner-icon": "mdi-close-circle",
                        "onClick:appendInner": _cache[2] || (_cache[2] = ($event) => (results.value = null)),
                        "bg-color": pageTheme.value == 'dark' ? '#ffffffaa' : '#3328470D',
                        items: results.value.map(m => ({ title: m.line1, value: m })),
                        "item-value": "value",
                        label: results.value && results.value.length + (results.value.length === 1 ? ' address found' : ' addresses found'),
                        "item-text": "address"
                    }, null, 8, ["modelValue", "bg-color", "items", "label"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
